import { render, staticRenderFns } from "./courseJxps.vue?vue&type=template&id=83bcc3bc&scoped=true&"
import script from "./courseJxps.vue?vue&type=script&lang=js&"
export * from "./courseJxps.vue?vue&type=script&lang=js&"
import style0 from "./courseJxps.vue?vue&type=style&index=0&id=83bcc3bc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83bcc3bc",
  null
  
)

export default component.exports